import {ARTICLE_PROMOTION_ARCHIVE_TYPE, ARTICLE_PROMOTION_OLD_TYPE} from 'app/utils/Consts';

export const isArticle = (type: string): boolean => type === 'news' ||
    type === 'blog' ||
    type === 'promotions' ||
    type === ARTICLE_PROMOTION_ARCHIVE_TYPE ||
    type === ARTICLE_PROMOTION_OLD_TYPE;
